import React, { useEffect, useState } from "react";
import SimpleButton from "../../../Components/layouts/simple_button";

const pollQuestions = [
  {
    question:
      "Before choosing my CEA type what are the early checks i need to do",
    options: [
      { id: "temprature", label: "Temperature", value: "0" },
      {
        id: "Humidity",
        label: "Humidity",
        value: "1",
      },
      {
        id: "Water Quality",
        label: "Water Quality",
        value: "2",
      },
      { id: "Temprature,humidity", label: "Temperature, Humidity", value: "3" },
    ],
  },
  {
    question: "Why indoor farming is not possible in india?",
    options: [
      { id: "rentsHigh", label: "Rents are too high", value: "0" },
      {
        id: "operationsCost",
        label: "Cost of operations too high",
        value: "1",
      },
      {
        id: "governmentPermission",
        label: "Government does not give permission",
        value: "2",
      },
      { id: "waterCost", label: "Water cost is too high", value: "3" },
    ],
  },

  {
    question: "Why we should not use hot water for farming?",
    options: [
      {
        id: "electricity",
        label: "Fertilisers don't mix up perfectly",
        value: "0",
      },
      {
        id: "awareness",
        label: "It damages the rootes of plants",
        value: "1",
      },
      {
        id: "infrastructure",
        label: "Hot water will reduce the life of system",
        value: "2",
      },
      {
        id: "highSetupCost",
        label: "Hot water will stop plants from having fruites",
        value: "3",
      },
    ],
  },
];
const WebinarPoll = ({ pollNumber, setPollNumber }) => {
  const [selectedOptions, setSelectedOptions] = useState("");
  useEffect(() => {
    if (pollNumber === 0 || pollNumber === 1 || pollNumber === 2) {
      const handlePollButton = () => {
        const btn = document.getElementById("pollButton");
        if (btn) btn.click();
      };

      handlePollButton();

      const timeoutId = setTimeout(() => {
        const closeBtn = document.getElementById("closePoll");
        if (closeBtn) closeBtn.click();
        setPollNumber(null);
      }, 60000); // 1 minutes

      return () => clearTimeout(timeoutId); // Cleanup on unmount or pollNumber change
    }
  }, [pollNumber]);

  const handleOptionChange = (index, optionId) => {
    setSelectedOptions((prevSelectedOptions) => {
      const newSelectedOptions = [...prevSelectedOptions];
      newSelectedOptions[index] = optionId;
      return newSelectedOptions;
    });
  };
  return (
    <>
      <button
        className="btn btn-primary"
        id="pollButton"
        data-bs-toggle="modal"
        data-bs-target="#modal-team"
        style={{ visibility: "hidden" }}
      >
        poll-button
      </button>
      <div
        className="modal modal-blur fade"
        id={`modal-team`}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        style={{ zIndex: 1000000 }}
      >
        <form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
          <div className="modal-dialog modal-dialog-centered w-100">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Poll</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setPollNumber(null)}
                  id="closePoll"
                ></button>
              </div>
              <div className="modal-body">
                {
                  <div className="mb-3">
                    <label className="form-label">
                      {pollQuestions?.[pollNumber].question}
                    </label>
                    <div>
                      {pollQuestions?.[pollNumber]?.options?.map((option) => (
                        <div key={option.id} className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name=""
                            id={option.id}
                            value={option.value}
                            checked={selectedOptions[pollNumber] === option.id}
                            onChange={() =>
                              handleOptionChange(pollNumber, option.id)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={option.id}
                          >
                            {option.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                }
              </div>
              <div className="modal-footer">
                <SimpleButton
                  buttonText="Submit"
                  data-bs-dismiss="modal"
                  onClick={() => setPollNumber(null)}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default WebinarPoll;
